// import routes from "../../routes";
import 'mapbox-gl/dist/mapbox-gl.css';

import { Route, Switch } from 'react-router-dom';
import routesAdminEasy360 from 'routes/routesAdminEasy360';

import Blank from './types/Blank';
import Default from './types/Default';

// Custom Chakra theme
export default function AdminDashboard() {
	const getActiveRoute = routes => {
		const activeRoute = 'Default Brand Text';

		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				const collapseActiveRoute = getActiveRoute(routes[i].items);
				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else if (routes[i].category) {
				const categoryActiveRoute = getActiveRoute(routes[i].items);
				if (categoryActiveRoute !== activeRoute) {
					return categoryActiveRoute;
				}
			} else {
				if (
					routes[i].name.includes('Editar') &&
					window.location.href.includes(
						routes[i].layout + routes[i].editPath
					)
				) {
					return routes[i];
				} else if (
					window.location.href.indexOf(
						routes[i].layout + routes[i].path
					) !== -1
				) {
					return routes[i];
				}
			}
		}
		return activeRoute;
	};
	const TemplatesPage = {
		default: Default,
		blank: Blank,
	};

	const getSwitchRoutes = routes => {
		const route = getActiveRoute(routes);
		const Template = TemplatesPage[route.templatePage || 'default'];
		return Object.entries(TemplatesPage).map(([templateKey]) => {
			return (
				<Template
					route={route}
					key={templateKey}
				>
					{getRoutes(routes, templateKey)}
				</Template>
			);
		});
	};

	const getRoutes = (routes, template) => {
		return routes.map((prop, key) => {
			const templatePageKey = prop.templatePage || 'default';
			if (prop.layout === '/adminEasy360') {
				return (
					<>
						{template === templatePageKey ? (
							<Route
								path={prop.layout + prop.path}
								component={prop.component}
								key={key}
							/>
						) : (
							<></>
						)}
					</>
				);
			}
			if (prop.collapse) {
				return getRoutes(prop.items, template);
			}
			if (prop.category) {
				return getRoutes(prop.items, template);
			} else {
				return null;
			}
		});
	};
	return (
		<>
			<Switch>{getSwitchRoutes(routesAdminEasy360)}</Switch>
		</>
	);
}
